import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { adminService } from '../../services/adminService';

const DomainsTab = () => {
  const [domains, setDomains] = useState([]);
  const [newDomain, setNewDomain] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadDomains();
  }, []);

  const loadDomains = async () => {
    setLoading(true);
    try {
      const data = await adminService.getSettings();
      setDomains(data.allowed_domains || []);
    } catch (e) {
      setError('Ошибка загрузки доменов');
    } finally {
      setLoading(false);
    }
  };

  const addDomain = async () => {
    const d = newDomain.trim().toLowerCase();
    if (!d || !d.includes('.') || domains.includes(d)) return;
    setSaving(true);
    try {
      const result = await adminService.updateSettings({
        allowed_domains: [...domains, d],
      });
      setDomains(result.allowed_domains || []);
      setNewDomain('');
      setError(null);
    } catch (e) {
      setError('Ошибка добавления домена');
    } finally {
      setSaving(false);
    }
  };

  const removeDomain = async (domain) => {
    setSaving(true);
    try {
      const result = await adminService.updateSettings({
        allowed_domains: domains.filter(d => d !== domain),
      });
      setDomains(result.allowed_domains || []);
      setError(null);
    } catch (e) {
      setError('Ошибка удаления домена');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-center py-8 text-paper-hint">Загрузка...</div>;

  return (
    <div className="mt-4 max-w-2xl">
      <p className="text-sm text-paper-ink-3 mb-4">
        Пользователи могут запрашивать токен только с email этих доменов
      </p>

      {error && <p className="text-paper-accent text-sm mb-3">{error}</p>}

      <div className="flex gap-2 mb-5">
        <Input
          className="max-w-xs"
          placeholder="example.com"
          value={newDomain}
          onChange={(e) => setNewDomain(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && addDomain()}
          disabled={saving}
        />
        <Button
          className="bg-paper-accent hover:bg-paper-accent-hover"
          size="sm"
          onClick={addDomain}
          disabled={saving || !newDomain.trim()}
        >
          Добавить
        </Button>
      </div>

      <div className="flex flex-wrap gap-2">
        {domains.map(domain => (
          <span
            key={domain}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-paper-panel rounded-chip bg-paper-bg text-sm"
          >
            {domain}
            <button
              className="text-paper-hint hover:text-paper-ink-2 text-xs"
              onClick={() => removeDomain(domain)}
              disabled={saving}
            >
              ✕
            </button>
          </span>
        ))}
      </div>

      <p className="text-xs text-paper-hint mt-4">
        {domains.length} {domains.length === 1 ? 'домен' : 'доменов'} • Изменения применяются мгновенно
      </p>
    </div>
  );
};

export default DomainsTab;
